import { useEffect, useRef } from 'react';
import { useScreenStore } from '../../stores/useScreenStore';
import { useAuthStore } from '../../stores/useAuthStore';
import { openFiltersWindow, closeFiltersWindow } from '../../utils/filtersWindow';
import { useLoadingStore } from '../../stores/useLoadingStore';
import { useSocketStore } from '../../stores/useSocketStore';
import { useToast } from '../toast/useToast';

export function useMonitorWindows() {

  const monitorMode = useScreenStore(state => state.monitorMode);

  const screen = useScreenStore(state => state.screen);

  const user = useAuthStore(state => state.user);

  const socket = useSocketStore(state => state.socket);

  const { warning } = useToast();

  const openingFiltersRef = useRef(false);

  const loadingClients = useLoadingStore(state => state.loadingClients);
  const loadingVehicles = useLoadingStore(state => state.loadingVehicles);
  const loadingDrivers = useLoadingStore(state => state.loadingDrivers);
  const loadingLines = useLoadingStore(state => state.loadingLines);
  const loadingTrips = useLoadingStore(state => state.loadingTrips);

  useEffect(() => {

    if (monitorMode !== 2 || !user) {

      openingFiltersRef.current = false;

      closeFiltersWindow();

      return;
    }

    if (
      !socket?.connected ||
      loadingLines ||
      loadingTrips ||
      loadingVehicles ||
      loadingDrivers ||
      loadingClients
    ) {
      return;
    }

    if (screen !== 'Home') {
      return;
    }

    if (openingFiltersRef.current) {
      return;
    }

    openingFiltersRef.current = true;

    useLoadingStore
      .getState()
      .startLoading(
        'Abrindo a tela de filtros...',
        false
      );

    console.log('⏳ AGENDANDO ABERTURA');

    setTimeout(() => {

      console.log('🟢 EXECUTANDO ABERTURA');

      const currentSocket =
        useSocketStore.getState().socket;

      const {
        monitorMode: currentMonitorMode,
        screen: currentScreen
      } = useScreenStore.getState();

      const {
        user: currentUser
      } = useAuthStore.getState();

      const {
        loadingClients: currentLoadingClients,
        loadingVehicles: currentLoadingVehicles,
        loadingDrivers: currentLoadingDrivers,
        loadingLines: currentLoadingLines,
        loadingTrips: currentLoadingTrips
      } = useLoadingStore.getState();

      if (
        currentMonitorMode !== 2 ||
        !currentUser ||
        currentScreen !== 'Home' ||
        !currentSocket?.connected ||
        currentLoadingClients ||
        currentLoadingVehicles ||
        currentLoadingDrivers ||
        currentLoadingLines ||
        currentLoadingTrips
      ) {

        console.log(
          '🟡 Abertura cancelada por mudança de estado'
        );

        openingFiltersRef.current = false;

        return;
      }

      const winOpened = openFiltersWindow();

      console.log(
        '🪟 RESULTADO:',
        winOpened
      );

      if (!winOpened) {

        openingFiltersRef.current = false;

        useLoadingStore
          .getState()
          .stopLoading();

        warning(
          'Não foi possível abrir tela de filtros. O sistema voltará para o modo de monitoramento em uma única tela.'
        );

        useScreenStore
          .getState()
          .setMonitorMode(1);
      }

    }, 1000);

  }, [
    socket,
    loadingTrips,
    loadingLines,
    loadingVehicles,
    loadingDrivers,
    loadingClients,
    monitorMode,
    screen,
    user,
    warning
  ]);

}